import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BroadcasterService } from '../broadcaster/broadcaster.service';
import { EConnectionStatus } from '../../enums/connection-status.enum';

@Injectable()
export class ErrorBroadcastService {
    constructor(private _broadcaster: BroadcasterService) {}

    onErrorCode(code: number): Observable<any> {
        const _errorCode = EConnectionStatus[`STATUS_${code}` as keyof typeof EConnectionStatus];
        return this._broadcaster.on<any>(_errorCode);
    }

    // Bad Request - Request failed
    on_400(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_400);
    }

    // Unauthorized - see "WWW-Authenticate" at header how the auth works
    on_401(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_401);
    }

    // Payment Required
    on_402(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_402);
    }

    // Forbidden - Missing rights
    on_403(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_403);
    }

    // Not Found
    on_404(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_404);
    }

    // Method Not Allowed - change request type (GET, POST, PUT, ...)
    on_405(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_405);
    }

    // Not Acceptable
    on_406(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_406);
    }

    // Proxy Authentication Required (RFC 7235)
    on_407(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_407);
    }

    // Request Time-out
    on_408(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_408);
    }

    // Conflict - login fails
    on_409(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_409);
    }

    // Gone
    on_410(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_410);
    }

    // Length Required
    on_411(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_411);
    }

    // Precondition Failed (RFC 7232)
    on_412(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_412);
    }

    // Payload Too Large (RFC 7231)
    on_413(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_413);
    }

    // URI Too Long (RFC 7231)
    on_414(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_414);
    }

    // Unsupported Media Type
    on_415(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_415);
    }

    // Range Not Satisfiable (RFC 7233)
    on_416(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_416);
    }

    // Expectation Failed
    on_417(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_417);
    }

    // I'm a teapot (RFC 2324) [Easter egg]
    on_418(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_418);
    }

    // Misdirected Request (RFC 7540)
    on_421(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_421);
    }

    // Unprocessable Entity (WebDAV; RFC 4918)
    on_422(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_422);
    }

    // Locked (WebDAV; RFC 4918)
    on_423(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_423);
    }

    // Failed Dependency (WebDAV; RFC 4918)
    on_424(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_424);
    }

    // Upgrade Required
    on_426(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_426);
    }

    // Precondition Required (RFC 6585)
    on_428(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_428);
    }

    // Too Many Requests (RFC 6585)
    on_429(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_429);
    }

    // Request Header Fields Too Large (RFC 6585)
    on_431(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_431);
    }

    // Login timeout - try to relogin again
    on_440(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_440);
    }

    // Invalid Token - try to relogin again
    on_498(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_498);
    }

    // Token Required - please login
    on_499(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_499);
    }

    // Unavailable For Legal Reasons (RFC 7725)
    on_451(): Observable<any> {
        return this._broadcaster.on<any>(EConnectionStatus.STATUS_451);
    }
}
